const _excluded = ["onHide", "show", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Modal } from '@isyc-react/design/bootstrap';
import { Button } from '@isyc-react/form/modules/base';
import "./filter-modal.style.scss";
export const FilterTableModal = props => {
  const {
      onHide,
      show,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Modal, _extends({
    centered: true,
    show: show,
    onHide: onHide,
    size: 'xl',
    scrollable: true
  }, rest), /*#__PURE__*/React.createElement(Modal.Header, {
    className: "bg-primary",
    closeButton: true,
    closeVariant: "white"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    as: 'h5'
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-filter me-3"
  }), "Filtrer tableau")), /*#__PURE__*/React.createElement(Modal.Body, null, children), /*#__PURE__*/React.createElement(Modal.Footer, {
    className: "border-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-content-center w-100 justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn btn-primary",
    onClick: () => onHide && onHide()
  }, "Fermer"))));
};